var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegretBannerRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 152,
    viewBox: "0 0 143 86",
    fill: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21689 -7.08597C10.8385 -9.41683 14.7702 -13.6236 21.5228 -0.518862C25.4845 7.16949 20.0534 43.4103 38.4608 56.3744C56.8683 69.3385 87.1098 41.0703 108.806 58.1832C131.64 76.194 96.3178 96.9957 119.591 114.532C138.21 128.561 169.881 135.68 172.495 129.502",
    stroke: "url(#paint0_linear_regret_right)",
    strokeWidth: 22
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_regret_right",
    x1: 24.9421,
    y1: 9.81835,
    x2: 171.297,
    y2: 116.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0192308,
    stopColor: "#7CC66E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442308,
    stopColor: "#299C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879808,
    stopColor: "#7CC66E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegretBannerRight);
export default __webpack_public_path__ + "static/media/RegretBannerRight.79318927680ec582d55f37e52222a24d.svg";
export { ForwardRef as ReactComponent };